import React, { FC, ReactElement } from 'react';
import Link from 'next/link';

type CountriesListItem = {
  name: string;
  url: string;
}

const CountriesListItem: FC<CountriesListItem> = ({ name, url }: CountriesListItem): ReactElement => {
  return (
    <Link className="freight-forwarder__countries-list-item" href={`freight-forwarder/${url}`}>{name}</Link>
  );
};

export default CountriesListItem;